import React, { useState } from "react";
import Avatar from "../../assets/img/default-image.jpg";
import ChatListItem from "../../components/common/ChatComponents/ChatListItem";
import { AdminLinkAction, AdminRowAction } from "../AdminDashboard/shared/adminUx";

const AllChats = ({ moveToChat, profileLinkOption, filterType = "all", onUserAvatarClick, hideGroupQuotes = false, showIndividualInboxes = false, isQuotesPage = false }) => {
  const [selectedChats, setSelectedChats] = useState(new Set());
  const [unblockedIds, setUnblockedIds] = useState(new Set());
  const isBlockedView = filterType === "blocked";

  // Realistic dummy data
  const allMessagesData = [
    {
      id: 1,
      image: `https://i.pravatar.cc/150?img=12`,
      Naming: "Sarah Mitchell",
      type: "PostInquiry",
      Message: "Hi, I saw your post about bathroom renovations. I'm interested in getting a quote for a complete bathroom remodel. The space is about 3x2 meters.",
      timing: "2 hours ago",
      isRead: false,
    },
    {
      id: 2,
      image: `https://i.pravatar.cc/150?img=33`,
      Naming: "Michael Chen",
      type: "message",
      Message: "Thanks for the quick response! Yes, we can come tomorrow at 10am to fix the leak under your sink. Please confirm the address again.",
      timing: "5 hours ago",
      isRead: false,
    },
    {
      id: 3,
      image: `https://i.pravatar.cc/150?img=47`,
      Naming: "Emma Thompson",
      type: "message",
      Message: "The electrician will be there between 2-4pm today. I'll send you a text when they're on their way.",
      timing: "1 day ago",
      isRead: true,
    },
    {
      id: 4,
      image: `https://i.pravatar.cc/150?img=52`,
      Naming: "David Rodriguez",
      type: "message",
      Message: "Great work on the kitchen! The tiles look fantastic. I'll leave a review on your profile.",
      timing: "2 days ago",
      isRead: true,
      deleted: true,
    },
    {
      id: 5,
      image: `https://i.pravatar.cc/150?img=68`,
      Naming: "Lisa Anderson",
      type: "PostInquiry",
      Message: "I need someone to install new gutters on my house. It's a two-story property. Can you provide a quote?",
      timing: "3 days ago",
      isRead: false,
      blocked: true,
    },
    {
      id: 6,
      image: `https://i.pravatar.cc/150?img=15`,
      Naming: "James Wilson",
      type: "message",
      Message: "The materials have arrived. We can start the project next Monday if that works for you?",
      timing: "4 days ago",
      isRead: true,
      deleted: true,
    },
    {
      id: 7,
      image: `https://i.pravatar.cc/150?img=28`,
      Naming: "Rachel Green",
      type: "message",
      Message: "Thank you so much for the excellent service! The painting job exceeded our expectations.",
      timing: "1 week ago",
      isRead: true,
      blocked: true,
    },
  ];

  const allQuotesData = [
    {
      id: 101,
      image: `https://i.pravatar.cc/150?img=12`,
      Naming: "Sarah Mitchell",
      type: "directQuote",
      Message: "Quote request for complete bathroom renovation - 3x2 meters, includes tiling, plumbing, and fixtures",
      timing: "2 hours ago",
      isRead: false,
      isDirectQuote: true,
    },
    {
      id: 102,
      image: `https://i.pravatar.cc/150?img=68`,
      Naming: "Lisa Anderson",
      type: "directQuote",
      Message: "Gutter installation quote needed for two-story property - approximately 50 meters of guttering",
      timing: "3 days ago",
      isRead: false,
      isDirectQuote: true,
    },
    {
      id: 103,
      image: Avatar,
      Naming: "Group Quote",
      type: "groupQuote",
      Message: "Quote request for bathroom renovation project - multiple businesses invited",
      timing: "1 day ago",
      isGroupQuote: true,
      isRead: false,
      groupRecipients: [
        { id: 1, name: "John Smith", image: `https://i.pravatar.cc/150?img=1`, userId: "user1" },
        { id: 2, name: "Sarah Johnson", image: `https://i.pravatar.cc/150?img=2`, userId: "user2" },
        { id: 3, name: "Mike Williams", image: `https://i.pravatar.cc/150?img=3`, userId: "user3" },
        { id: 4, name: "Emily Brown", image: `https://i.pravatar.cc/150?img=4`, userId: "user4" },
        { id: 5, name: "David Davis", image: `https://i.pravatar.cc/150?img=5`, userId: "user5" },
      ],
    },
    {
      id: 104,
      image: `https://i.pravatar.cc/150?img=45`,
      Naming: "Robert Taylor",
      type: "directQuote",
      Message: "Kitchen cabinet installation quote - 12 linear meters, modern style, includes handles and installation",
      timing: "5 days ago",
      isRead: true,
      isDirectQuote: true,
      deleted: true,
    },
    {
      id: 105,
      image: Avatar,
      Naming: "Group Quote",
      type: "groupQuote",
      Message: "Roof repair quote request - multiple quotes needed for comparison",
      timing: "1 week ago",
      isGroupQuote: true,
      isRead: true,
      groupRecipients: [
        { id: 6, name: "Tom Anderson", image: `https://i.pravatar.cc/150?img=6`, userId: "user6" },
        { id: 7, name: "Jessica Martinez", image: `https://i.pravatar.cc/150?img=7`, userId: "user7" },
        { id: 8, name: "Chris Lee", image: `https://i.pravatar.cc/150?img=8`, userId: "user8" },
      ],
    },
    {
      id: 106,
      image: `https://i.pravatar.cc/150?img=25`,
      Naming: "Jennifer White",
      type: "directQuote",
      Message: "Need a quote for deck construction - 6x4 meters, treated pine, includes railings",
      timing: "2 weeks ago",
      isRead: true,
      isDirectQuote: true,
      deleted: true,
    },
    {
      id: 107,
      image: `https://i.pravatar.cc/150?img=38`,
      Naming: "Mark Thompson",
      type: "directQuote",
      Message: "Requesting quote for electrical rewiring - 3 bedroom house, full rewire required",
      timing: "3 weeks ago",
      isRead: true,
      isDirectQuote: true,
    },
  ];

  // Use quotes data if on quotes page, messages data for messages, or combined for deleted
  const data =
    filterType === "deleted"
      ? [...allMessagesData.filter((m) => m.deleted), ...allQuotesData.filter((q) => q.deleted)]
      : filterType === "blocked"
        ? allMessagesData.filter((m) => m.blocked && !unblockedIds.has(m.id))
      : isQuotesPage
        ? allQuotesData
        : allMessagesData;

  // Filter data based on filterType and hideGroupQuotes
  let filteredData = data.filter((item) => {
    if (filterType === "deleted" || filterType === "blocked") return true;
    // Hide group quotes if hideGroupQuotes is true
    if (hideGroupQuotes && (item.isGroupQuote || item.type === "groupQuote")) {
      return false;
    }
    if (filterType === "all") return true;
    if (filterType === "PostInquiry") return item.type === "PostInquiry";
    if (filterType === "unread") return !item.isRead;
    if (filterType === "archive") return false;
    return true;
  });

  // If showIndividualInboxes is true, expand group quotes into individual inboxes
  if (showIndividualInboxes) {
    const expandedData = [];
    filteredData.forEach(item => {
      if (item.isGroupQuote && item.groupRecipients && item.groupRecipients.length > 0) {
        // Expand group quote into individual inboxes
        item.groupRecipients.forEach(recipient => {
          expandedData.push({
            ...item,
            id: `${item.id}-${recipient.id}`,
            image: recipient.image,
            Naming: recipient.name,
            isGroupQuote: false,
            groupRecipients: [],
            originalGroupQuoteId: item.id,
            recipientUserId: recipient.userId,
            recipientData: recipient, // Store recipient data for onClick handler
          });
        });
      } else {
        expandedData.push(item);
      }
    });
    filteredData = expandedData;
  }

  const handleCheckboxChange = (chatId, isChecked) => {
    setSelectedChats(prev => {
      const newSet = new Set(prev);
      if (isChecked) {
        newSet.add(chatId);
      } else {
        newSet.delete(chatId);
      }
      return newSet;
    });
  };

  const hasSelectedChats = selectedChats.size > 0;

  const handleUnblock = (chatId) => {
    setUnblockedIds((prev) => new Set([...prev, chatId]));
  };

  return (
    <>
      <div className="divide-y divide-lightgray">
        {filteredData.map((e, index) => {
          const isLastItem = index === filteredData.length - 1;
          return (
            <div
              key={index}
              className={isLastItem ? "!border-b !border-lightgray" : ""}
            >
              <ChatListItem
                checkBox={false}
                onClick={() => {
                  if (e.recipientData && onUserAvatarClick) {
                    onUserAvatarClick(e.recipientData);
                  } else {
                    moveToChat();
                  }
                }}
                profileImage={e.image}
                profileName={e.Naming}
                lastMsg={e.Message}
                timeStamp={e.timing}
                chatId={e.id}
                isChecked={selectedChats.has(e.id)}
                onCheckboxChange={handleCheckboxChange}
                messageType={e.type}
                isGroupQuote={e.isGroupQuote || false}
                groupRecipients={e.groupRecipients || []}
                onUserAvatarClick={onUserAvatarClick}
                isUnread={!e.isRead}
                rightAction={
                  isBlockedView ? (
                    <AdminRowAction type="button" onClick={() => handleUnblock(e.id)}>
                      Unblock
                    </AdminRowAction>
                  ) : undefined
                }
              />
            </div>
          );
        })}
      </div>
      {hasSelectedChats && (
        <div className="px-4 py-4 lg:px-6">
          <div className="flex items-center gap-4 flex-wrap">
            <AdminLinkAction type="button" className="!text-mediumgray hover:!text-alertred">
              Delete
            </AdminLinkAction>
            <AdminLinkAction type="button" className="!text-mediumgray hover:!text-offblack">
              Block
            </AdminLinkAction>
            <AdminLinkAction type="button" className="!text-mediumgray hover:!text-offblack">
              Archive
            </AdminLinkAction>
            {profileLinkOption && (
              <AdminLinkAction type="button" className="!text-mediumgray hover:!text-offblack">
                Visit profile
              </AdminLinkAction>
            )}
          </div>
        </div>
      )}
      {/* <div className="px-4 py-8 lg:px-6">
        <SpecialText
          variant={"FootNoteDisclaimer"}
          className={"text-center text-gray-400 text-sm"}
        >
          You've reached the end of the list.
        </SpecialText>
      </div> */}
    </>
  );
};

export default AllChats;
